import { environment } from '../../environments/environment';

export function getFileDownloadUrl(fileId: string) {
  return environment.apiUrl + '/api/download-file/' + fileId;
}
